import { showSuccessToast } from '@shared/toasts';
import { Routes } from '@domain/router';
import { createMiddleware } from '../../../shared/redux';
import {
    fetchBillingCenterInfo,
    CANCEL_SUBSCRIPTION_REQUESTED,
    NEW_ADDON_SUBSCRIPTION_REQUESTED,
    PAYMENT_METHOD_UPGRADE_REQUESTED,
    PLAN_UPGRADE_REQUESTED, fetchBillingCenterInvoices,
} from './center.state';
import { closeChangePaymentModal, openOrderModal } from '../interface/interface.state';
import { UPDATE_SUBSCRIPTION, getSubscriptionData } from '../subscription/subscription.state';
import { BILLING_CENTER } from './center.constants';
import {
    CREATE_STRIPE_CUSTOMER_REQUEST_SUCCEEDED,
    UPDATE_STRIPE_CUSTOMER_REQUEST_SUCCEEDED,
} from '../stripe/stripe-customer';
import { STRIPE_CUSTOMER_TEXTS } from '../stripe/stripe-customer/stripe-customer.constants';

const handleStripeCustomerSuccessOnBillingCenter = (state) => {
    const route = state.router.location.pathname;
    if (route === Routes.BILLING_CENTER) {
        return [
            closeChangePaymentModal(),
            showSuccessToast({
                message: STRIPE_CUSTOMER_TEXTS.CREATE_PAYMENT_METHOD_SUCCEEDED,
            }),
        ];
    }
    return [];
};

export const billingCenterMiddleware = createMiddleware({
    [PLAN_UPGRADE_REQUESTED]: (_, action) => [
        openOrderModal({
            planId: action.payload.planId,
            source: BILLING_CENTER,
        }),
    ],
    [NEW_ADDON_SUBSCRIPTION_REQUESTED]: (state, action) => {
        const subscription = getSubscriptionData(state);
        const addonIds = subscription.addonIds || [];

        return openOrderModal({
            addonIds: [...addonIds, action.payload.addonId],
            source: BILLING_CENTER,
        });
    },
    [PAYMENT_METHOD_UPGRADE_REQUESTED]: () => {},
    [CANCEL_SUBSCRIPTION_REQUESTED]: () => {},
    [UPDATE_SUBSCRIPTION]: () => [
        fetchBillingCenterInfo(),
        fetchBillingCenterInvoices(0, true),
    ],
    [CREATE_STRIPE_CUSTOMER_REQUEST_SUCCEEDED]: handleStripeCustomerSuccessOnBillingCenter,
    [UPDATE_STRIPE_CUSTOMER_REQUEST_SUCCEEDED]: handleStripeCustomerSuccessOnBillingCenter,
});
